import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ComplainHttpService } from 'src/app/http/complain-http.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
    selector: 'app-complain-new',
    templateUrl: './complain-new.component.html',
    styles: [],
})
export class ComplainNewComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        private complainHttpService: ComplainHttpService,
        private router: Router,
        public location: Location,
        private activatedRoute: ActivatedRoute,
        private sharedService: SharedService
    ) {}

    newComplaintForm = this.fb.group(
        {
            branchId: [null, Validators.required],
            title: [null, Validators.required],
            subTitle: [null, Validators.required],
            customerName: [null, Validators.required],
            customerPhone: [null, Validators.required],
            description: [null, Validators.required],
            status: ['Open', Validators.required],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    branches: any[] = [];

    compliansTitles = this.sharedService.compliansTitles;

    compliansSubTitles = this.sharedService.compliansSubTitles;

    compliansStatus = this.sharedService.compliansStatus;

    compliansSubTitlesCurrent: any[] = [];

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.branches = data.data;
        });
    }

    onChange(ev: any) {
        this.compliansSubTitlesCurrent = this.compliansSubTitles.filter((c) => c.title === ev.value);
        this.newComplaintForm.controls['subTitle'].setValue(null);
    }

    onSubmit() {
        this.newComplaintForm.markAsTouched();
        if (this.newComplaintForm.valid) {
            this.formBusy = true;
            const value = this.prepareForm(this.newComplaintForm.value);
            this.complainHttpService.newComplain(value).subscribe(
                () => {
                    this.router.navigateByUrl('/management/complain-list', {
                        state: { hasState: true, type: 'success', message: 'Complain Created successfully' },
                    });
                },
                () => {
                    this.formBusy = false;
                    this.newComplaintForm.setErrors({ exists: true });
                }
            );
        }
    }

    prepareForm(data: any) {
        return {
            branchId: data.branchId,
            title: data.title,
            subTitle: data.subTitle,
            customerName: data.customerName,
            customerPhone: data.customerPhone,
            status: data.status,
            complainsDetails: [
                {
                    description: data.description,
                    status: data.status,
                },
            ],
        };
    }
}
